<template>
    <div>
        <discount-form :create="true" @saved="editDiscount"></discount-form>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        methods: {
            editDiscount(discount) {
                this.$router.push({name: 'discount', params: {id: discount.id}})
            }
        }
    };
</script>



// WEBPACK FOOTER //
// DiscountCreate.vue?40fe12ae